export default "__VITE_ASSET__BwVn2Pf$__"